import highlight from "@mdx-deck/themes/syntax-highlighter-prism";
import baseTheme from "../../../../../../theme";
import { Appear, Notes } from "mdx-deck";
import { Gif } from "../../../../../../gif";
import { FlexCenter, FlexColumn, FlexSplit } from "../../../../../../flex";
import Layout from "../../../../../../layout";
import brace from "../../../../../../images/2016.jpg";
import soBad from "../../../../../../images/soBad.jpg";
import stackOverflow from "../../../../../../images/stack-overflow.png";
import sOaxe from "../../../../../../images/so-axe.png";
import coolPug from "../../../../../../images/cool-pug.jpg";
import pugGif from "../../../../../../images/pug.gif";
import thanks from "../../../../../../images/thanks.jpg";
import React from 'react';
export default {
  highlight: highlight,
  baseTheme: baseTheme,
  Appear: Appear,
  Notes: Notes,
  Gif: Gif,
  FlexCenter: FlexCenter,
  FlexColumn: FlexColumn,
  FlexSplit: FlexSplit,
  Layout: Layout,
  brace: brace,
  soBad: soBad,
  stackOverflow: stackOverflow,
  sOaxe: sOaxe,
  coolPug: coolPug,
  pugGif: pugGif,
  thanks: thanks,
  React: React
};